import React from 'react';
import PropTypes from 'prop-types';
import DisableOnActionInProgress from '../../../../Common/Components/DisableOnActionInProgress.jsx';
import RatesFiltersSummary from './RatesFiltersSummary.jsx'
import RatesFiltersView from './RatesFiltersView.jsx'

class RatesSearchView extends React.Component {
    render() {
        return (
            <section id="RatesSearchView">
                <form>
                    <div className="segment">
                        <RatesFiltersSummary
                            searchCriteria={ this.props.searchCriteria }
                            options={ this.props.options } />
                        <RatesFiltersView
                            searchCriteria={ this.props.searchCriteria }
                            options={ this.props.options } />
                        <div className="right aligned container">
                            <DisableOnActionInProgress>
                                <button
                                    id="View"
                                    type="submit"
                                    className="primary button"
                                    onClick={ (e) => { this.props.onViewRequested(); e.preventDefault(); } }>
                                    View
                                </button>
                                <button
                                    id="Download"
                                    type="button"
                                    className="button"
                                    onClick={ this.props.onExportRequested }>
                                    Download
                                </button>
                            </DisableOnActionInProgress>
                        </div>
                    </div>
                </form>
            </section>
        );
    }

    static propTypes = {
        options: PropTypes.object.isRequired,
        searchCriteria: PropTypes.object.isRequired,
        onExportRequested: PropTypes.func.isRequired, // onExportRequested()
        onViewRequested: PropTypes.func.isRequired // onViewRequested()
    };
}

export default RatesSearchView;
